module.exports = __webpack_public_path__ + "img/14.c2b8f889.png";